import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { SplashMessage } from '../../lib/splash-message';

export interface SplashMessageState extends EntityState<SplashMessage> {}

export const splashMessageAdapter: EntityAdapter<SplashMessage> = createEntityAdapter<SplashMessage>({
  selectId: message => message.id,
});
